import type { FC, ReactElement } from "react"

import { type NavigateFunction, useNavigate } from "react-router-dom"
import { useMount } from "react-use"

import { Spinner } from "@/3514/components"
import { EPath } from "@/3514/constants"

/**
 * @deprecated backward compatibility for old route
 */
const CoachingSessionsPage: FC = (): ReactElement => {
    const navigate: NavigateFunction = useNavigate()

    useMount((): void => {
        void navigate(EPath.Participant_CoachingSessions(), { replace: true })
    })

    return <Spinner wrapperClassName="mt-[50px]" />
}

export { CoachingSessionsPage }
